import { mat4MultiplyInto } from './mat4-multiply-into.js';
import { allocateMat4 } from './_matrix-allocator.js';

function mat4Multiply(a, b) {
  const out = allocateMat4();
  mat4MultiplyInto(out, 0, a, 0, b, 0);
  return out;
}

export { mat4Multiply };
//# sourceMappingURL=mat4-multiply.js.map
